import { render, staticRenderFns } from "./service-left-icon.vue?vue&type=template&id=75dd70ba"
import script from "./service-left-icon.vue?vue&type=script&lang=js"
export * from "./service-left-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports